import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 48, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterHeader = ({ number, title, sub, light = false }) => (
  <div className="mb-14 sm:mb-20">
    <Reveal>
      <div className="flex items-end gap-5 sm:gap-8">
        <span className="font-mono-x text-4xl sm:text-6xl font-bold text-stroke-chili leading-none select-none">
          {number}
        </span>
        <div className="h-px flex-1 mb-3 bg-gradient-to-r from-leaf/50 to-transparent" />
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        className={`font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-6xl mt-6 leading-[1.02] ${
          light ? "text-bone" : "text-ember"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.2}>
        <p
          className={`text-base md:text-lg leading-relaxed max-w-2xl mt-5 ${
            light ? "text-cream" : "text-leafdark"
          }`}
        >
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
